import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Logo } from '@openx/components-core/lib/Logo/Logo.tsx';
import type { JSX } from 'react';
import { StyledBackground } from '../../components/Background/Background.styled.tsx';
import { StyledContainer } from './components/Container.styled.tsx';
import { StyledSubtitleTypography } from './components/SubtitleTypography.styled.tsx';
import { useGetErrorProps } from './hooks/useGetErrorProps.ts';

type ErrorComponentProps = {
  errorType?: 404 | 500;
};

export const ErrorPage = ({ errorType = 500 }: ErrorComponentProps): JSX.Element => {
  const { title, subtitle, navigateTo, buttonLabel } = useGetErrorProps(errorType);

  return (
    <StyledBackground>
      <Logo invertColors />
      <StyledContainer data-test="error-container">
        <Typography variant="display" component="p" sx={{ mb: 3 }}>
          {title}
        </Typography>
        <StyledSubtitleTypography variant="body1">{subtitle}</StyledSubtitleTypography>
        <Button data-test="error-action-button" variant="contained" onClick={navigateTo}>
          {buttonLabel}
        </Button>
      </StyledContainer>
    </StyledBackground>
  );
};
